import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    input
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { SonaFaviconComponent } from '@sona/angular-ui-components';
import { ITarget } from '@sona/shared-model-common';

@Component({
    selector: 'sona-target-link',
    templateUrl: './target-link.component.html',
    styleUrl: './target-link.component.scss',
    imports: [ SonaFaviconComponent, RouterLink ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SonaTargetLinkComponent {
    readonly target = input.required<ITarget | undefined>();
    readonly disabled = input(false, { transform: booleanAttribute });
    readonly subtitle = input<string>();
}
